<template>
<div id="app">
     <headcom :number="number" :marqueeInfo="marqueeInfo" :state="state"></headcom>
     <eggcom v-on:childZa="childZa" v-on:showtanchuan="showtanchuan" ref="mychild"></eggcom>
     <div class="pimg">
         <img src="/static/images/jiangpin.png" />
     </div>
     <awardcom :myawardDate="myawardDate" :myawardLevel="myawardLevel" :myawardStoreName="myawardStoreName" v-if="myisaward"></awardcom>
     <div class="foot">
         <div class="comm">
             <h1 class="text"></h1>
         </div>
     </div>
     <wincom v-show="showwin" :isCurLevel="isCurLevel" v-on:againparent="againparent"></wincom>
</div>
</template>
<script>
import headcom from '@/components/head'
import eggcom from '@/components/egg'
import awardcom from '@/components/award'
import wincom from '@/components/win'
import axios from 'axios'
let qs = require("qs")
const querystring = require('querystring');

export default {
    name:"app",
    components:{
        headcom,
        eggcom,
        awardcom,
        wincom
    },
    data() {
        return{
            //小程序字段
            phone:"18688886666",
            address:"",
            storeName:"",
            name:"",

            //是否有资格
            luckVal:-1,

            //剩余次数
            number: "",
            //设置当前这次是否中奖 0：未中奖 1：一等奖 2.. 3.. 4..
            isCurLevel:0,
            //显示中奖弹窗
            showwin: false,

            //我的中奖信息
            myisaward:false,    //是否中奖
            myawardDate:"",     //中奖日期
            myawardLevel:"",    //中奖等级
            myawardStoreName:"",//中奖门店

            //滚动信息
            marqueeInfo:"",

            //活动状态 0:未开始 1进行中 2已结束
            state:-1
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init:function () {
             var that = this;

            var url = window.location.search.replace('?',"");
            var parms = querystring.parse(url);
            this.phone=parms.p;
            this.name=decodeURIComponent(parms.n);
            this.address=decodeURIComponent(parms.a);
            this.storeName=decodeURIComponent(parms.s);

            //先判断活动时间
            this.getLotteryDate(()=>{
                //次数
                this.getsurnum(()=>{
                    //我的奖品
                    this.getmyaward();
                });                
            });
            
            //去滚动信息
            this.getMarquee();
        },
        //活动时间
        getLotteryDate:function(callback){
            var that = this;
                   
            this.$api.post('/api/lottery/getActStatus',{},function(res) {
                    if(!res || res.rspCode!="success"){
                        that.state = 0;
                        that.$refs.mychild.setStopState();
                        return;
                    }
                    that.state = 0;
                    if(res.data){
                        //抽奖活动状态（-1：未知；0：未开始；1：正常；2：已结束）
                        that.state = res.data < 0 ? 0 : res.data;
                    }
                    //未开始不跳动
                    if(that.state==0){
                        that.$refs.mychild.setStopState();
                    }
                    if(typeof callback =="function"){
                        callback()
                    }
                },
                function(res){
                    that.$refs.mychild.setStopState();
                    //活动状态
                    that.state = 0;
                }
            );
        },
        //获取剩余次数
        getsurnum:function(callback){
            var that = this;
            //从缓存里面去剩余次数
            var num = that.getLocalStorage("number"+that.phone);
            var luckVal = that.getLocalStorage("luckVal"+that.phone);
            //如果缓存里面有值
            if(num !=null && luckVal!=null){
                //次数
                that.number = num;
                //幸运指数
                that.luckVal = luckVal;
                if(typeof callback =="function"){
                    callback()
                }
                return;
            }
            
            var parms = {
                phone: that.phone,
            }
            this.$api.post('/api/lottery/getRemainTimes',parms,function(res) {
                    if(!res || res.rspCode!="success"){
                        //保存时间 - 保存到今天24点
                        var sytime = that.getCurTimeTo24Time();
                        that.setLocalStorage("number"+that.phone,3,sytime);
                        that.number = 3;
                        return;
                    }
                    //记录次数
                    var number = res.data.remainTimes || 3;
                    //保存时间 - 保存到今天24点
                    var sytime = that.getCurTimeTo24Time();
                    that.setLocalStorage("number"+that.phone,number,sytime);
                    that.number = number;
                    //幸运指数
                    that.luckVal = res.data.luckVal;

                    that.setLocalStorage("luckVal"+that.phone,that.luckVal,sytime);
                    if(typeof callback =="function"){
                        callback()
                    }
                },
                function(res){
                    //保存时间 - 保存到今天24点
                    var sytime = that.getCurTimeTo24Time();
                    that.setLocalStorage("number"+that.phone,3,sytime);
                    that.number = 3;
                }
            );
        },
        //锤子锤玩事件
        showtanchuan:function(data){
            var that = this;

            //判断幸运资格
            if(that.luckVal <= 0){

                var number = that.getLocalStorage("number"+that.phone);
                number = number - 1;
                //保存时间 - 保存到今天24点
                var sytime = that.getCurTimeTo24Time();
                that.setLocalStorage("number"+that.phone,number,sytime);
                that.number = number;
                //显示弹窗
                that.showwin = true;
                //设置为未中奖
                that.isCurLevel = 0;
            
                return false;
            }

            var parms = {
                phone: that.phone,
                address: that.address,
                storeName: that.storeName,
                name: that.name,
            }
            this.$api.post('/api/lottery/draw',parms,function(res) {
                    if(!res || res.rspCode!="success"){
                        //报错也显示未中奖
                        var number = that.getLocalStorage("number"+that.phone);
                        number = number - 1;
                        //保存时间 - 保存到今天24点
                        var sytime = that.getCurTimeTo24Time();
                        that.setLocalStorage("number"+that.phone,number,sytime);
                        that.number = number;
                        //显示弹窗
                        that.showwin = true;
                        //设置为未中奖
                        that.isCurLevel = 0;
                        return;
                    }
                    //显示弹窗
                    that.showwin = true;

                    var number = that.getLocalStorage("number"+that.phone);
                    number = (number - 1)>0?(number - 1):0
                    //保存时间 - 保存到今天24点
                    var sytime = that.getCurTimeTo24Time();
                    that.setLocalStorage("number"+that.phone,number,sytime);
                    that.number = number;
                    
                    if(res.data.isLuckyDog){
                        //设置已中奖 中了几等级
                        that.isCurLevel = res.data.prizeLevel;
                        //获取我的奖品
                        that.getmyaward();

                    }else{
                        //设置未中奖
                        that.isCurLevel = 0;
                    }        
                },
                function(res){
                    //报错也显示未中奖
                    var number = that.getLocalStorage("number"+that.phone);
                    number = number - 1;
                    //保存时间 - 保存到今天24点
                    var sytime = that.getCurTimeTo24Time();
                    that.setLocalStorage("number"+that.phone,number,sytime);
                    that.number = number;
                    //显示弹窗
                    that.showwin = true;
                    //设置为未中奖
                    that.isCurLevel = 0;
                }
            );
        },
        //再来一次
        againparent:function(){
            // if(!this.zaEggQual()){
            //     return;
            // }
            //关闭弹窗
            this.showwin = false;
            //默认为未中奖
            this.isCurLevel = 0;
            this.$refs.mychild.again();
        },
        childZa:function(i){
            if(!this.zaEggQual()){
                return;
            }
            this.$refs.mychild.eggZa(i);
        },
        //判断资格
        zaEggQual:function(){
            var that = this;
            if(that.state!=1){
                return false;
            }
            var number = that.number;
            
            if(number==0){
                $.alert("今天已经敲完了，明天再来吧");
                return false;
            }            
            return true;
        },
        
        //获取我的奖品
        getmyaward:function(){
            var that = this;
            var luckVal = that.getLocalStorage("luckVal"+that.phone);
            //luckVal值为0的时候不需要查，不能中奖
            if(luckVal==null || luckVal==0){
                return;
            }
            //从缓存里面取奖品信息
            var myisaward = that.getLocalStorage("myisaward"+that.phone);
             //从缓存里面取奖品信息
            var myawardDate = that.getLocalStorage("myawardDate"+that.phone);
             //从缓存里面取奖品信息
            var myawardLevel = that.getLocalStorage("myawardLevel"+that.phone);
            var myawardStoreName = that.getLocalStorage("myawardStoreName"+that.phone);
            if(myisaward!=null){
                //我的奖品
                that.myisaward = myisaward;
                that.myawardDate = myawardDate;
                that.myawardLevel = myawardLevel;
                that.myawardStoreName = myawardStoreName;
                return;
            }
            

            var parms = {
                phone: that.phone,
            }
            this.$api.get('/api/lottery/getMyLuckRecord',parms,function(res) {
                    if(!res || res.rspCode!="success"){
                        return;
                    }
                    if(res.data){
                        //我的奖品
                        that.myisaward = res.data.isLuckyDog;
                        that.myawardDate = res.data.luckDrawDate;
                        that.myawardLevel = res.data.prizeLevel;
                        that.myawardStoreName = res.data.storeName;
                        
                        //保存localstorage
                        //保存时间-一个小时
                        var s = 1 * 60 * 60;
                        that.setLocalStorage("myisaward"+that.phone,that.myisaward, s);
                        that.setLocalStorage("myawardDate"+that.phone,that.myawardDate, s);
                        that.setLocalStorage("myawardLevel"+that.phone,that.myawardLevel, s);
                        that.setLocalStorage("myawardStoreName"+that.phone,that.myawardStoreName, s);
                    }
                },
                function(res){
                    that.myisaward = false;
                }
            );
        },
        //滚动信息
        getMarquee:function(){
            var that = this;
            //先从缓存里面取
            var marqueeStr = that.getLocalStorage("marqueeInfo");
            
            if(marqueeStr){
                that.marqueeInfo=marqueeStr;
                return;
            }
            this.$api.get('/api/lottery/getLatestLuckDogs',{},function(res) {
                    if(!res || res.rspCode!="success"){
                        return;
                    }
                    if(res.data){
                        var marqueeInfo = "";
                        res.data.forEach(item => {
                            var prizeLevelStr = item.prizeLevel==1?"一等奖":
                                             item.prizeLevel==2?"二等奖":
                                             item.prizeLevel==3?"三等奖":
                                             item.prizeLevel==4?"幸运奖":"";
                            var lottery = item.prizeLevel==1?"金猪一个":
                                              item.prizeLevel==2?"梦洁乳胶枕一个":
                                              item.prizeLevel==3?"康巴赫不粘锅一个":
                                              item.prizeLevel==4?"乐扣保温杯一个":"";
                            marqueeInfo += `【${item.storeName}】 ${item.name}获得${prizeLevelStr}，${lottery}。`;
                        });

                        if(marqueeInfo.length >0){
                            that.marqueeInfo= "恭喜"+marqueeInfo;
                            //保存时间-20分钟
                            var s = 1 * 60 * 20;
                            that.setLocalStorage("marqueeInfo",that.marqueeInfo,s);
                        }
                    }
                },
                function(res){
                }
            );
        },
        /**
       * 设置cookie
       * @param {[type]} key   [键名]
       * @param {[type]} value [键值]
       * @param {[type]} second  [保存的时间（秒）]
       */
      setLocalStorage: function (key, value, second) {
        // 设置过期原则
        if (!value && value!=0) {
          localStorage.removeItem(key)
        } else {
          var secondTime = (second || 3600 * 24)*1000; // 默认保留1天
          var exp = new Date();
          localStorage[key] = JSON.stringify({
            value,
            expires: exp.getTime() + secondTime
          })
        }
      },
      getLocalStorage: function (name) {
        try {
          let o = JSON.parse(localStorage[name])
          if (!o || o.expires < Date.now()) {
            return null
          } else {
            return o.value
          }
        } catch (e) {
            // 兼容其他localstorage 
          console.log(e)
          return localStorage[name]
        } finally {
        }
      },
      //目前距离下个0点还剩多少秒
      getCurTimeTo24Time:function(){
            var x=new Date();
            x.setHours(0,0,0,0);
            var y = new Date();
            var sum= (24*3600*1000-(y.getTime()-x.getTime()))/1000;
            return sum;
      }

    }
}
</script>




// WEBPACK FOOTER //
// src/pages/home/index.vue